export const getParentPathname = (url: string): string => url.split('/')[1];

export const getLastPathname = (url: string): string =>
  url.split('/')[url.split('/').length - 1] ?? '';

export const getLastTabPathname = (url: string, position = 3): string =>
  url.split('/')[position] ?? '';
